import { Row, Col, Container } from "react-bootstrap";
import { MockProfilesDashboard } from "../../../Public/Landingpages/Components/MockScreens";

const Profiles = () => {
  return (
    <>
      <Container>
        <Row
          style={{
            position: "relative",
            border: "0px solid #000000",
            paddingTop: "4.5rem",
            paddingBottom: "5.5rem",
          }}
        >
          <Col className="bluedotProfile">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="700"
              height="953"
              viewBox="0 0 700 953"
              fill="none"
            >
              <g opacity="0.8" filter="url(#filter0_f_254_9150)">
                <circle cx="224" cy="476.486" r="76" fill="#45C546" />
              </g>
              <defs>
                <filter
                  id="filter0_f_254_9150"
                  x="-252"
                  y="0.486084"
                  width="952"
                  height="952"
                  filterUnits="userSpaceOnUse"
                  color-interpolation-filters="sRGB"
                >
                  <feFlood flood-opacity="0" result="BackgroundImageFix" />
                  <feBlend
                    mode="normal"
                    in="SourceGraphic"
                    in2="BackgroundImageFix"
                    result="shape"
                  />
                  <feGaussianBlur
                    stdDeviation="200"
                    result="effect1_foregroundBlur_254_9150"
                  />
                </filter>
              </defs>
            </svg>
          </Col>
          <Col md={10} className="mx-auto" style={{ textAlign: "center" }}>
            <span className="blueSubheaderTop">Create Multiple Profiles</span>
            <div
              className="landingpageHeader"
              style={{ fontWeight: "400", lineHeight: "110%", marginTop: "0.5rem" }}
            >
              More Success in Project Applications with multiple Profiles
            </div>
            <p className="landingpageDescriptions" style={{ maxWidth: "600px", margin: "0 auto 1.5rem" }}>
              Applying with a profile tailored to a specific job description
              significantly increases your chances of success. Stand out by
              personalizing your approach and choose from multiple user-friendly
              templates.
            </p>
            <p style={{ fontStyle: "italic", color: "#888", marginBottom: "2rem" }}>
              Coming soon: Application tracking and personalized job search
            </p>
            <div style={{ display: "inline-block", maxWidth: "70%", width: "100%", textAlign: "left" }}>
              <MockProfilesDashboard />
            </div>
          </Col>
        </Row>
      </Container>
    </>
  );
};

export default Profiles;
